import { ColorConstants } from './index';

const ADS_IN_EXCESS_BACKGROUND = 'linear-gradient(180deg, #3BBBAB, #AC7CF1)';
const ADS_OVER_DAYS_BACKGROUND = 'linear-gradient(109deg, #FFADB2 50%, #FDE6A2 100%)';
const BRAND_DAMAGE_ALERT_BACKGROUND = ColorConstants.portage;
const BID_MODIFIER_DECREASE_ADJUST_BACKGROUND = 'linear-gradient(180deg, #EC96E5, #FB8289)';
const BID_MODIFIER_INCREASE_ADJUST_BACKGROUND = 'linear-gradient(180deg, #8EAFDF, #3BBBAB)';
const DISPLAY_FRAUD_FINDER_BACKGROUND = 'linear-gradient(103deg, rgba(236,150,229,1) 0%, rgba(236,150,229,1) 23%, rgba(251,130,137,1) 57%, rgba(251,130,137,1) 100%)';
const DISPLAY_PERFORMANCE_BACKGROUND = 'linear-gradient(103deg, rgba(236,150,229,1) 0%, rgba(236,150,229,1) 23%, rgba(251,130,137,1) 57%, rgba(251,130,137,1) 100%)';
const DSA_CAMPAIGN_BACKGROUND = 'linear-gradient(90deg, #ec96e5 0%, #fb8289 100%)';
const FACEBOOK_CREATIVE_EXPERIMENT_BACKGROUND = 'linear-gradient(135deg, rgba(172,102,251,1) 4%, rgba(85,130,243,1) 47%, rgba(53,195,163,1) 100%)';
const GOOGLE_BANNER_EXPERIMENTS_BACKGROUND = ColorConstants.portage;
const MOBILE_APPS_PERFORMANCE_BACKGROUND = 'linear-gradient(135deg, rgba(150,217,213,1) 26%, rgba(115,226,147,1) 50%)';
const SMART_BUDGET_DECREASE_ADJUST_BACKGROUND = 'linear-gradient(153deg, rgba(150,217,213,1) 0%, rgba(236,150,229,1) 0%, rgba(251,130,137,1) 28%)';
const SMART_BUDGET_INCREASE_ADJUST_BACKGROUND = 'linear-gradient(153deg, rgba(150,217,213,1) 0%, rgba(150,217,213,1) 0%, rgba(115,226,147,1) 50%)';
const TEMPLATE_SUGGESTION = 'linear-gradient(141deg, #35C3A3 0%, #5582F3 51%, #AC66FB 75%)';

export {
    ADS_IN_EXCESS_BACKGROUND,
    ADS_OVER_DAYS_BACKGROUND,
    BRAND_DAMAGE_ALERT_BACKGROUND,
    BID_MODIFIER_DECREASE_ADJUST_BACKGROUND,
    BID_MODIFIER_INCREASE_ADJUST_BACKGROUND,
    DISPLAY_FRAUD_FINDER_BACKGROUND,
    DISPLAY_PERFORMANCE_BACKGROUND,
    DSA_CAMPAIGN_BACKGROUND,
    FACEBOOK_CREATIVE_EXPERIMENT_BACKGROUND,
    GOOGLE_BANNER_EXPERIMENTS_BACKGROUND,
    MOBILE_APPS_PERFORMANCE_BACKGROUND,
    SMART_BUDGET_DECREASE_ADJUST_BACKGROUND,
    SMART_BUDGET_INCREASE_ADJUST_BACKGROUND,
    TEMPLATE_SUGGESTION,
};
